import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { toast } from "react-toastify";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

import { createEnquiryAPI } from "../../helpers/backend_helper";
import { checkPermissionStatus } from "helpers/utils";
import { useTranslation } from "react-i18next";

function CreateEnquiry(props) {
  const { t } = useTranslation();

  const [formDataValues, setFormDataValues] = useState({});

  /* =========================
     HANDLE INPUT CHANGE
  ========================== */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =========================
     HANDLE SUBMIT
  ========================== */
  const handleSubmit = async values => {
    try {
      const payload = {
        subject: values.subject,
        description: values.description,
        priority: "NORMAL",
      };

      const res = await createEnquiryAPI(payload);

      if (res?.data?.status) {
        toast.success(t("Enquiry.Created Successfully"));

        setTimeout(() => {
          props.history.push("/enquiries");
        }, 1000);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Create enquiry error:", err);
      toast.error("Failed to create enquiry");
    }
  };

  /* =========================
     THEME SETUP (SAME AS DEPARTMENT)
  ========================== */
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  /* =========================
     PERMISSION CHECK
  ========================== */
  if (!checkPermissionStatus("enquiries", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">
          {t("Enquiry.Access Denied")}
        </h4>
      </div>
    );
  }

  /* =========================
     RENDER
  ========================== */
  return (
    <React.Fragment>
      <div className="page-content">
        {/* Header */}
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/enquiries">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="back" />
                  {t("Enquiry.Create Enquiry")}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        {/* Form Wrapper */}
        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-4">
            <Container fluid>
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => handleSubmit(formDataValues)}
                >
                  <div className="outer">
                    <Row>
                      {/* SUBJECT */}
                      <Col lg="6">
                        <FormGroup className="mb-2" row>
                          <Label
                            htmlFor="subject"
                            className="col-form-label"
                          >
                            {t("Enquiry.Subject")}
                            <span className="text-danger">*</span>
                          </Label>

                        <AvField
  type="text"
  name="subject"
  id="subject"
  className="form-control"
  placeholder={t("Enquiry.Subject")}
  value={formDataValues?.subject || ""}
  onChange={handleChange}
  validate={{
    required: {
      value: true,
      errorMessage: t("Enquiry.Subject required"),
    },
    minLength: {
      value: 5,
      errorMessage: t("Enquiry.Subject minimum 5 characters"),
    },
    maxLength: {
      value: 100,
      errorMessage: t("Enquiry.Subject max 100 characters"),
    },
    pattern: {
      value: "^[a-zA-Z0-9\\s.,!?-]+$",
      errorMessage: t(
        "Only letters, numbers and basic punctuation (.,!?-) are allowed"
      ),
    },
  }}
/>
                        </FormGroup>
                      </Col>

                      {/* DESCRIPTION */}
                      <Col lg="6">
                        <FormGroup className="mb-2" row>
                          <Label
                            htmlFor="description"
                            className="col-form-label"
                          >
                            {t("Enquiry.Description")}
                            <span className="text-danger">*</span>
                          </Label>

                          <AvField
                            type="textarea"
                            name="description"
                            id="description"
                            rows="4"
                            className="form-control"
                            placeholder={t("Enquiry.Describe your issue")}
                            value={formDataValues?.description || ""}
                            onChange={handleChange}
validate={{
  required: {
    value: true,
    errorMessage: t("Enquiry.Description required"),
  },
  minLength: {
    value: 10,
    errorMessage: t("Enquiry.Description minimum 10 characters"),
  },
  maxLength: {
    value: 500,
    errorMessage: t("Enquiry.Description max 500 characters"),
  },
  pattern: {
    value: "^[a-zA-Z0-9\\s.,!?@#&()_:/\\-'\"]+$",
    errorMessage: t("Invalid characters in description"),
  },
}}
                          />
                        </FormGroup>
                      </Col>

                      {/* CTA BUTTONS */}
                      <div className="cta text-center gap-3 d-flex justify-content-start mt-4 mb-4">
                        <Button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() =>
                            props.history.push("/enquiries")
                          }
                        >
                          {t("Common.Cancel")}
                        </Button>

                        <Button
                          type="submit"
                          className="btn btn-primary"
                             color="success"
                        >
                          {t("Common.Submit")}
                        </Button>
                      </div>
                    </Row>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateEnquiry;
